/* =============================================================================
   CORE / RECIPE-ENTITY — Entitäts-bewusstes Framing der Rezept-/Zutaten-Maske (S188-2b)
   =============================================================================
   Nordstern EINDEUTIGKEIT: dieselbe Maske (recipe_items → ingredients, keyed by
   menu_item_id) wird je nach itemType anders gerahmt:
     • Wahl-Item (itemType option/extra) → Modus „ingredient": GENAU EINE Zutat
       (Single-Picker), keine Rezept-Schritte/Stationen. Button/Titel „Zutat".
     • Speise (itemType main/…)          → Modus „recipe": mehrere Zutaten + Schritte.
   Ein Code-Pfad, zwei Framings — kein Zweit-Editor. Pure/testbar, keine DOM/Storage.
============================================================================ */

export const RECIPE_MODE = Object.freeze({ INGREDIENT: 'ingredient', RECIPE: 'recipe' });

/** itemType → Framing-Modus. option/extra = 'ingredient', sonst 'recipe'. */
export function entityModeForItemType(itemType) {
  return (itemType === 'option' || itemType === 'extra') ? RECIPE_MODE.INGREDIENT : RECIPE_MODE.RECIPE;
}

/** Ist dieser Modus die Single-Zutat-Sicht (Wahl-Item)? */
export function isIngredientMode(mode) { return mode === RECIPE_MODE.INGREDIENT; }

/** Labels/Framing je Modus (Titel, Tiefen-Button, Speichern, leer-Zustand). */
export function recipeLabels(mode) {
  return isIngredientMode(mode)
    ? {
        title: 'Zutat', button: 'Zutat', icon: '🥗',
        save: 'Zutat speichern',
        empty: 'Noch keine Zutat verknüpft.',
        picker: 'Zutat aus der Warenwirtschaft',
        noNutrition: 'Zutat ohne Nährwerte – bitte pflegen',
        noLink: 'Keine Zutat verknüpft'
      }
    : {
        title: 'Rezept', button: 'Rezept', icon: '🧾',
        save: 'Rezept speichern',
        empty: 'Noch keine Zutaten im Rezept.',
        picker: 'Zutat',
        noNutrition: 'Nährwerte unvollständig',
        noLink: 'Kein Rezept hinterlegt'
      };
}

/** Labels direkt aus dem itemType (Bequemlichkeit für die UI). */
export function recipeLabelsForItemType(itemType) {
  return recipeLabels(entityModeForItemType(itemType));
}

/**
 * S188-2b-Fix — Single-Zutat-Zeile für den Save eines Wahl-Items normalisieren.
 * Im Gegensatz zum Speisen-Rezept ist die MENGE optional (Nährwerte kommen aus der
 * Zutat): ist eine Zutat gewählt, aber keine (gültige, >0) Menge gesetzt → Default 1.
 * Ohne gewählte Zutat → null (= „entfernen": setItems bekommt [] und löscht die Zeile).
 * Genau EINE Zeile pro Option (der Aufrufer übergibt [row].filter(Boolean)).
 * @returns {null | {ingredientId,quantity,unit,isOptional,sortOrder,stepNo,stepText,station}}
 */
export function cleanIngredientRow(row) {
  const r = row || {};
  if (!r.ingredientId) return null;
  const q = Number(r.quantity);
  return {
    ingredientId: r.ingredientId,
    quantity: (r.quantity != null && r.quantity !== '' && isFinite(q) && q > 0) ? q : 1,
    unit: r.unit || 'base',
    isOptional: false,
    sortOrder: 0,
    stepNo: null, stepText: null, station: null
  };
}
